/* RESPONSIBLE TEAM: team-phone */
import type HoldAndAssign from 'embercom/models/operator/visual-builder/step/hold-and-assign';
import StepConfig, { type StepConfigParams } from '../step';

export default class HoldAndAssignConfiguration extends StepConfig {
  declare step: HoldAndAssign;

  constructor(params: Omit<StepConfigParams, 'component'> & { component?: string }) {
    super({
      component: 'workflows/graph-editor/node-items/steps/hold-and-assign',
      ...params,
    });
  }

  get alignment() {
    return 'left' as const;
  }
}
